(function(){
  var drawer=document.querySelector("[data-cart-drawer]"),
      scrim=document.querySelector("[data-cart-scrim]");
  if(!drawer) return;
  var body=drawer.querySelector("[data-cart-body]"),
      foot=drawer.querySelector("[data-cart-foot]"),
      shipEl=drawer.querySelector("[data-cart-ship]"),
      subEl=drawer.querySelector("[data-cart-subtotal]");
  var FREE=49900; // 499 lei prag livrare gratuită (ca în Markets → România → Livrare)
  var FLASH_MS=4000; // cât rămâne vizibil mesajul de limită
  var maxes={};   // variant_id -> cantitatea maximă (stoc); din templates/cart.amcmax.liquid
  function limitMsg(n){ return n ? "Limită de cantitate atinsă ("+n+" buc.)" : "Limită de cantitate atinsă"; }
  // mesaj general (rezervă, când nu știm linia), dispare singur
  var msgEl=document.createElement("div"); msgEl.className="cd-msg"; msgEl.hidden=true; msgEl.setAttribute("role","status");
  msgEl.style.cssText="margin:10px 20px 0;padding:10px 12px;border-radius:10px;background:rgba(109,31,44,.08);color:#6D1F2C;font-size:.85rem;line-height:1.35";
  body.parentNode.insertBefore(msgEl,body);
  var msgTimer=null;
  function showMsg(t){ clearTimeout(msgTimer); msgEl.textContent=t||""; msgEl.hidden=!t; if(t) msgTimer=setTimeout(function(){ msgEl.hidden=true; },FLASH_MS); }
  // mesaj sub produsul care a atins limita; dispare singur
  function flashItem(sel,n){
    var item=body.querySelector(".cd-item"+sel);
    if(!item){ showMsg(limitMsg(n)); return; }
    var mid=item.querySelector(".cd-mid")||item;
    var old=mid.querySelector(".cd-limit"); if(old) old.remove();
    var el=document.createElement("div"); el.className="cd-limit"; el.setAttribute("role","status"); el.textContent=limitMsg(n);
    el.style.cssText="margin-top:6px;font-size:.8rem;line-height:1.3;color:#6D1F2C;transition:opacity .4s ease";
    mid.appendChild(el);
    setTimeout(function(){ el.style.opacity="0"; setTimeout(function(){ el.remove(); },450); },FLASH_MS);
  }
  function money(c){ return (c/100).toLocaleString("ro-RO",{minimumFractionDigits:2,maximumFractionDigits:2})+" lei"; }
  function thumb(u){ return u ? u+(u.indexOf("?")>-1?"&":"?")+"width=160" : ""; }
  function open(){ drawer.classList.add("is-open"); if(scrim)scrim.classList.add("is-open"); drawer.setAttribute("aria-hidden","false"); document.body.classList.add("cart-open"); }
  function close(){ drawer.classList.remove("is-open"); if(scrim)scrim.classList.remove("is-open"); drawer.setAttribute("aria-hidden","true"); document.body.classList.remove("cart-open"); showMsg(""); }
  function setCount(n){ document.querySelectorAll(".cart-count").forEach(function(el){ el.setAttribute("data-n",n); el.textContent=n; }); }
  function maxFor(it){ var m=maxes[String(it.variant_id)]; return (typeof m==="number") ? m : null; }
  // coș gol: textul pragului, ca în bara de anunțuri („peste 499 lei”); cu produse: cât mai lipsește până la 499 lei
  function renderShip(sub){
    if(!shipEl) return;
    if(sub>=FREE){ shipEl.innerHTML='<strong>Felicitări! Ai livrare gratuită.</strong><div class="cd-ship-bar"><i style="width:100%"></i></div>'; }
    else if(!sub){ shipEl.innerHTML='Livrare gratuită pentru comenzile de peste <strong>499 lei</strong>.<div class="cd-ship-bar"><i style="width:2%"></i></div>'; }
    else { var pct=Math.max(2,Math.min(100,Math.round(sub/FREE*100)));
      shipEl.innerHTML='Mai adaugă <strong>'+money(FREE-sub)+'</strong> pentru livrare gratuită.<div class="cd-ship-bar"><i style="width:'+pct+'%"></i></div>'; }
  }
  // prețul unitar al liniei (cu prețul vechi tăiat dacă are reducere)
  function unitHTML(it){
    var old = it.original_price>it.final_price ? '<s style="opacity:.6;margin-right:4px">'+money(it.original_price)+'</s>' : '';
    return '<div class="cd-unit" style="margin-top:2px;font-size:.85rem;color:var(--ink-2)">'+old+money(it.final_price)+'</div>';
  }
  function render(cart){
    setCount(cart.item_count);
    renderShip(cart.items_subtotal_price||0);
    if(!cart.item_count){
      body.innerHTML='<div class="cd-empty"><svg class="icon"><use href="#i-bag"/></svg><p>Coșul tău e gol.</p></div>';
      foot.hidden=true; return;
    }
    var h="";
    cart.items.forEach(function(it){
      var vt = (it.variant_title && it.variant_title!=="Default Title") ? '<div class="vr">'+it.variant_title+'</div>' : "";
      var mx=maxFor(it), atMax=(mx!==null && it.quantity>=mx);
      h+='<div class="cd-item" data-key="'+it.key+'" data-vid="'+it.variant_id+'">'
        +'<a class="art" href="'+it.url+'">'+(it.image?'<img src="'+thumb(it.image)+'" alt="" loading="lazy">':'')+'</a>'
        +'<div class="cd-mid"><a class="nm" href="'+it.url+'">'+it.product_title+'</a>'+vt+unitHTML(it)
        +'<div class="cd-qrow">'
          +'<div class="cd-qty"><button type="button" data-dec aria-label="Scade">−</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Crește"'+(atMax?' disabled':'')+'>+</button></div>'
          +'<div class="pr">'+money(it.final_line_price)+'</div>'
        +'</div>'
        +'<button type="button" class="rm" data-rm>Elimină</button></div>'
        +'</div>';
    });
    body.innerHTML=h;
    if(subEl) subEl.textContent=money(cart.items_subtotal_price);
    foot.hidden=false;
  }
  function getCart(){ return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}); }
  // fără header Accept: application/json, altfel Shopify ignoră view-ul și întoarce /cart.json
  function getMaxes(){
    return fetch("/cart?view=amcmax").then(function(r){return r.text();})
      .then(function(t){ try{ maxes=JSON.parse(t)||{}; }catch(e){ maxes={}; } }).catch(function(){ maxes={}; });
  }
  // coș + stocuri; dacă o linie depășește stocul (ex. adăugată înainte de limită), o readuce la maxim
  function refresh(openIt){
    return Promise.all([getCart(),getMaxes()]).then(function(r){
      var c=r[0], over=null;
      c.items.forEach(function(it){ var mx=maxFor(it); if(!over && mx!==null && mx>0 && it.quantity>mx) over={key:it.key,mx:mx}; });
      if(over){
        return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:over.key,quantity:over.mx})})
          .then(function(){ return refresh(openIt); })
          .then(function(c2){ flashItem('[data-key="'+over.key+'"]',over.mx); return c2; });
      }
      render(c); if(openIt) open(); return c;
    });
  }
  function withStatus(r){ return r.json().then(function(j){ return {ok:r.ok,status:r.status,j:j}; }); }
  function change(key,qty){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:qty})})
      .then(withStatus)
      .then(function(res){
        if(res.ok){ showMsg(""); return refresh(false); }
        // 422 = peste stoc; cantitatea rămasă în coș e chiar maximul
        return refresh(false).then(function(c){
          var q=0; c.items.forEach(function(it){ if(it.key===key) q=it.quantity; });
          flashItem('[data-key="'+key+'"]',q);
          var inc=body.querySelector('.cd-item[data-key="'+key+'"] [data-inc]'); if(inc) inc.disabled=true;
        });
      })
      .catch(function(){ refresh(false); });
  }
  // intercept any add-to-cart form -> AJAX + open drawer
  // Shopify verifică stocul doar pentru cantitatea din cererea curentă, nu și pentru ce e deja în coș,
  // așa că limităm aici: stoc (data-max pe input-ul id) minus cantitatea deja aflată în coș.
  document.addEventListener("submit",function(e){
    var f=e.target;
    if(!f || !f.getAttribute) return;
    var act=f.getAttribute("action")||"";
    if(act.indexOf("/cart/add")<0) return;
    e.preventDefault();
    var btn=f.querySelector("[type=submit]"); if(btn) btn.setAttribute("aria-busy","true");
    function done(){ if(btn) btn.removeAttribute("aria-busy"); }
    var idIn=f.querySelector("[name=id]"), qIn=f.querySelector("[name=quantity]");
    var vid=idIn ? String(idIn.value) : "";
    var mx=idIn ? parseInt(idIn.getAttribute("data-max"),10) : NaN;
    var want=qIn ? (parseInt(qIn.value,10)||1) : 1;
    var fd=new FormData(f), limited=false;
    function flashThis(){ flashItem('[data-vid="'+vid+'"]', isNaN(mx) ? 0 : mx); }
    showMsg("");
    (isNaN(mx) ? Promise.resolve(null) : getCart()).then(function(cart){
      if(cart){
        var inCart=0;
        cart.items.forEach(function(it){ if(String(it.variant_id)===vid) inCart+=it.quantity; });
        var room=mx-inCart;
        if(room<=0){ done(); return refresh(true).then(flashThis); }
        if(want>room){ fd.set("quantity",room); limited=true; }
      }
      return fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:fd})
        .then(withStatus)
        .then(function(res){
          done();
          if(res.ok){ return refresh(true).then(function(){ if(limited) flashThis(); }); }
          if(res.status===422){ return refresh(true).then(flashThis); }
          throw 0;
        });
    }).catch(function(){ f.submit(); });
  });
  // header cart icon opens drawer
  document.querySelectorAll("[data-cart-toggle]").forEach(function(a){
    a.addEventListener("click",function(e){ e.preventDefault(); showMsg(""); refresh(true); });
  });
  if(scrim) scrim.addEventListener("click",close);
  document.addEventListener("keydown",function(e){ if(e.key==="Escape") close(); });
  drawer.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest("[data-cart-close]")){ close(); return; }
    var item=t.closest(".cd-item"); if(!item) return;
    var key=item.getAttribute("data-key");
    var qEl=item.querySelector(".cd-qty span"), q=parseInt(qEl?qEl.textContent:"1",10)||1;
    var inc=t.closest("[data-inc]");
    if(inc){ if(!inc.disabled) change(key,q+1); }
    else if(t.closest("[data-dec]")) change(key,Math.max(0,q-1));
    else if(t.closest("[data-rm]")) change(key,0);
  });
})();
